<template>
  <div class="home">

    <section class="landing">

      <!-- Foto di sfondo -->
      <div class="landing-bg">
        <div class="overlay"></div>
      </div>

      <!-- Contenuto landing page -->
      <div>
        <img class="decorazioni" src="../assets/SX.png" alt="Elementi decorativi">
        <img v-if="!isMobile" class="ragazza" src="../assets/HOME_tipa.png" alt="mani ragazza che salda a stagno">
        <h2 class="titolo">Soluzioni complete per il settore automotive</h2>
        <img class="freccia" src="../assets/Freccia.png" alt="scrolla verso il basso">
      </div>

    </section>

    <section class="servizi-section">
    <div class="servizi-wrapper">

      <!-- Foto a sinistra -->
      <div class="servizi-img">
        <img src="../assets/home.png" alt="I nostri servizi">
      </div>

      <!-- Testo sulla destra -->
      <div class="servizi-text">
        <h2 class="titolo_servizi">I NOSTRI SERVIZI</h2>
        <h3>Progettazione Hardware, Software e cablaggi</h3>
        <p>Grazie al nostro ufficio tecnico interno siamo in grado di avere una gamma di prodotti completa e personalizzabile in base alle esigenze applicative dell'utente finale.</p>
        <h3>Lavorazioni CNC</h3>
        <p>Il nostro reparto di meccanica con due Centri Controllo Numerico permette di lavorare scatole commerciali ma anche di realizzare prodotti speciali dal pieno in alluminio o delrin. Inoltre il servizio di ingegnerizzazione e stampa 3D permette di valutare ed avere fra le mani il prototipo in tempi brevissimi</p>
        <h3>Produzione e collaudi</h3>
        <p>Con il nostro reparto di produzione interno garantiamo qualità e tracciabilità! Inoltre il nuovissimo reparto cablaggi permette di offrire oltre alle centraline di nostra produzione anche il gruppo cavi in modo da offrirvi un servzio completo, funzionante e pronto da installare sulla vostra applicazione.</p>
      </div>

  </div>
    </section>

    <section class="applicazioni-section">

      <h2 class="section-title">APPLICAZIONI</h2>

      <div class="cards-container">
        <div
          class="app-card"
          v-for="(app, index) in applicazioni"
          :key="index"
        >
          <div class="card-image">
            <img :src="app.img" :alt="app.title" />
          </div>

          <div class="card-content">
            <h3>{{ app.title }}</h3>
            <p>{{ app.text }}</p>
          </div>
        </div>
      </div>

    </section>

  </div>
</template>


<script>
    export default {
      name: 'HomePage',
      props: {
        msg: String
      },
      data() {
        return {
          windowWidth: window.innerWidth,
          applicazioni: [
          {
            title: 'Piattaforme aeree',
            text: `Negli anni Tecnoservice si è sempre distinta in questo settore. Con l'esperienza acquisita sul campo siamo in grado di assistere il cliente nelle proprie scelte, accompagnandolo verso un prodotto di successo.`,
            img: require('@/assets/piattaforme.jpg')
          },
          {
            title: 'Gru per autocarri',
            text: `Grazie alle unità progettate specificatamente per questo settore siamo in grado di fornire centraline affidabili tanto da produrre una linea certificata TUV per ceste autolivellanti.`,
            img: require('@/assets/gru_gialla.png')
          },
          {
            title: 'Spargisale e lame neve',
            text: `Il lavorare in situazioni climatiche estreme e particolarmente intense come le emergenze neve ha permesso di testare l'affidabilità della nostra elettronica e delle soluzioni proposte.`,
            img: require('@/assets/lama-spargisale-1.jpg')
          },
          {
            title: 'Rasaerba radiocomandati',
            text: `La partnership con un nostro cliente ha permesso di realizzare un prodotto versatile, sicuro ed efficiente sotto ogni aspetto, integrando sistemi all'avanguardia in questo nuovo campo di lavoro.`,
            img: require('@/assets/robot-rasaerba.jpeg')
          }
          ]
        }
      },
      computed: {
        isMobile() {
          return this.windowWidth <= 768; // breakpoint classico
        }
      },
      methods: {
        handleResize() {
          this.windowWidth = window.innerWidth;
        }, 
      },
      mounted() {
        window.addEventListener('resize', this.handleResize);
      },
      beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
      }
    }
</script>

<style lang="scss" scoped>

/*#region landing*/
.landing {

  //La posizion relative serve per far si che la landing non vada sotto la nav-bar a livello vizivo
  position: relative;

  //Questa riga fa in modo che se qualche elemento va fuori dalle dimensioni indicate verrà nascosto
  overflow: hidden;

  /*
  La dimensione della landing. Non è 100% perchè deve stare tra le barre nere senza andarci sotto, e senza andare sotto 
  alla barra di navigazione
  */
  height: 78vh;
}


//Sfondo landing page
.landing-bg {
  /*
  Il position:absolute serve per poter cambiare lo z-index dell'elemento "div" al quale lo sfondo è associato
  Così facendo possiamo assegnare lo z-index=0, che non fa altro che dire al codice che questo elemento deve stare al
  di sotto di tutto il resto, in quando di base lo z-index è 1
  */
  position: absolute;
  inset: 0;
  background-image: url("../assets/landing_bg.jpg");
  background-size: cover;
  background-position: center;
  z-index: 0;

  //Patina bianca semi-trasparente che si trova sopra lo sfondo
  .overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(255, 255, 255, 0.7);
  }
}

//Elementi della landing-page
.decorazioni { //Sono gli elementi geometrici colorati che si trovano in basso a sinistra

  //Queste righe servono a fissarli in basso a sinistra della sezione "landing" 
  position: absolute;
  left: -2%;
  bottom: -7%;


  width: 25vw;
  z-index: 1;
}

.ragazza { //la foto della ragazza che salda sulla destra della pagina (l'elemento verde fa parte della foto)

  //Queste righe servono a posizionarla
  position: absolute;
  right: -12%;
  bottom: 0;
  
  height: 100%;
  z-index: 2;
}

.titolo { //Questo è il titolo che compare sulla landing-page

  /*
  Questo serve a posizionare il testo al centro della landing-page
  Il problema è che quello che viene messo al centro è l'angolo in alto a destra del riquadro del testo
  */
  position: absolute;
  top: 50%;
  left: 50%;

  /*
  Questa riga serve a fare in modo che sia il centro del testo ad essere centrale (se entrambi i valori fossero -50%)
  ma in quanto lo voglio spostato più a sinistra, il valore orizzontale è più alto
  */
  transform: translate(-80%, -50%);
  
  font-size: 3.5rem;
  text-transform: uppercase; //Questo fa in modo che il testo sia tutto in maiuscolo ed evita errori di battitura
  text-align: left;
  z-index: 3;
}

.freccia { //La freccia che fa su e giù nella parte bassa della landing

  //Codice per posizionarla
  position: absolute;
  bottom: 5%;

  height: 5vh;

  //Codice per l'animazione, l'animazione "upAndDown" si trova in fondo allo style sheet
  animation: upAndDown 3s ease-in-out infinite;
}

/*#endregion */


/* #region servizi */

//Questo serve a dividere le due colonne e lasciare uno spazione tra di loro (5vw)
.servizi-wrapper {
  display: flex;
  align-items: center;
  gap: 5vw;
}

.servizi-section {
  //Questo codice serve per avere spazio a destra e sinistra (5vw) e sopra e sotto (10vh)
  padding: 10vh 5vw;
  
  .servizi-text {
    width: 40vw;

    h2 { 
      //Dimensione del titol odi questa sezione
      font-size: 2.3rem;
    }
    h3 { 
      //Dimensione del titolo dei paragrafi della sezione
      font-size: 1.5rem;

      //Queste righe serve per distnziare i titoli dei pragarafi da quello che hanno sopra e sotto
      margin-top: 4vh;
      margin-bottom: 2vh;

      color: orange;
    }
    p { 
      //Dimensione del testo dei paragrafi
      font-size: 1.1rem;

      //Questo codice serve a far andare il testo fino alla fine della riga così da avere dei blocchi ben definiti di testo
      text-align: justify;
      hyphens: auto;
      word-break: break-word;
    }
  }
  
}

.servizi-img {
  //Questo serve a dimensionare il contenitore della foto in modo che occupi lo spazio giusto rispetto al testo
  flex: 1;
  transform: translate(-20%);

  img {
    //Questo serve per far si che la foto occupi tutto lo spazio del suo contenitore
    width: 100%;
    height: 100%;
  }
}

/* #endregion */

/* #region Applicazioni */

.applicazioni-section {
  //Questa riga serve a dare spazio ai lati
  padding: 0 5vw;
}

//Titolo della sezione
.section-title {
  position: relative;
  text-align: center;
  font-size: 2.3rem;
  margin-bottom: 6vh;

  &::after {
    //Tutto questo codice serve a creare la barra verde al di sotto della scritta "Applicazioni"
    content: "";
    display: block;
    background-color: $tcan_green;
    margin: 1.5vh auto 0;
    width: 10vw;
    height: 5px;
  }
}

.cards-container {
  /*
  Questo è il contenitore dei 4 paragrafi sulle nostre applicazioni
  Questo codice serve a dare le distanze e gli allineamenti delle sezioni al suo interno
  */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 2vw;
}

//Singola applicazione
.app-card {

  //Queste sono le impostazioni per ogni card delle varie applicazioni
  width: calc(25% - 1.5vw); //Questa riga calcola quanto deve essere larga ogni card per farle entrare tutte in una riga
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: $tcan_green;
  color: white;
  
  //per far si che l'hover non si attivi all'istante ma abbia del movimento fluido
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

//Queste righe indicano cosa succederà quando il mouse passerà su una delle card
.app-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.25);
}


.card-image {
  padding-top: 0.5%; //per avere il bordino verde sopra la foto
  min-height: 33%; //L'altezza minima delle foto è il 33% della card
  height: 45%;

  img {
    width: 99%; //per avere il bordino verde ai lati della foto
    height: 100%;
    object-fit: cover;
  }
}


//Contenuto delle card
.card-content {
  padding: 2vh 1vw;
  flex: 1;
  text-align: left;
  
  h3 {
    font-size: 1.5rem;
    margin-bottom: 2rem;
  }
  
  p {
    font-size: 1.1rem;
    hyphens: auto;
    overflow-wrap: break-word;
    word-break: break-word;
  }
}
/* #endregion */


/* Da qui iniziano le definizioni di stile per la versione mobile del sito web */
/* #region Mobile  */

@media screen and (max-width: 768px) {

  /* #region landing */
  .landing {
    height: 50vh;
  }
  .titolo { 
    //Questo è il titolo che compare sulla landing-page nella versione mobile
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 2.8rem;
    text-transform: uppercase;
    text-align: center;
    z-index: 3;
    width: 90vw;
  }
  .decorazioni {
    position: absolute;
    left: -2%;
    bottom: -2%;
    width: 40vw;
    z-index: 1;
  }
/* #endregion */

  /* #region servizi */

  .servizi-wrapper {
    flex-direction: column;
    gap: 5vh;

    /* 
    Dopo aver ditrutto il contenitore servizi-text possiamo ordinare gli elementi che conteneva e l'immagine
    in modo da ottenere un layout migliore da mobile, in modo da avere prima il titolo della sezione, poi la foto
    e infine il resto della sezione. Se non avessimo distrutto il contenitore questa cosa non sarebbe stata possibile
    in quanto avremmo potuto ordinare solamente la foto e il contenitorer servizi-text
    */ 
    .titolo_servizi {
      order: 1;
    }
    .servizi-img {
      order: 2;
    }
    h3, p {
      order: 3;
    }
  }
  .servizi-img {
    transform: translate(-10%);
  }
  .servizi-section {
    .servizi-text {
      display: contents; //serve per "distruggere" il contenitore e liberane il contenuto
      h3 {
        font-size: 1.8rem;
      }
      p {
        font-size: 1.3rem;
      }
    }
  }
  /* #endregion */
  
}

/* #region applicazioni */

.section-title::after {
  width: 20vw;
}

.cards-container {
  gap: 5vh;
}

.app-card {
  width: 90vw;
}

/* #endregion */
/* #endregion  */

/*
Qui viene definita l'animazione della freccia che si muove nella landing-page
Indichiamo con i keyframes i momenti nei quali deve succedere qualcosa durante il tempo indicato
0 e 100 sono il punto di partenza e di fine. In questo caso siccome è un Loop voglio che questi momenti coincidano
A metà del tempo voglio che la freccia sia spostata del 50% rispetto all'inizio e sia trasparente
La pagina si occuperà da sola di fare in modo che la transazione sia omogenea e bella da vedere
*/
@keyframes upAndDown {
  0% {
    transform: translateY(0);
    opacity: 0.5;
  }

  50% {
    transform: translateY(50%);
    opacity: 1;
  }

  100% {
    transform: translateY(0);
    opacity: 0.5;
  }
}

</style>
